// extracted by mini-css-extract-plugin
export default {"grid":"Zones_grid__A34kh"};